'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const TextGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

interface PageHeaderProps {
  $listing?: boolean;
}

export const PageHeader = styled.h1<PageHeaderProps>`
  font-size: ${({ theme, $listing }) =>
    $listing ? theme.typography.title.fontSize : theme.typography.heading1.fontSize};
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${({ theme, $listing }) =>
    $listing ? theme.typography.title.fontWeight : theme.typography.heading1.fontWeight};
  line-height: ${({ theme, $listing }) =>
    $listing ? theme.typography.title.lineHeight : theme.typography.heading1.lineHeight};
  padding-bottom: ${(props) => (props.$listing ? Spacers.XS : Spacers.BASE)}rem;
`;

interface TextProps {
  dark?: boolean;
}

export const Text = styled.div<TextProps>`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme, dark }) =>
    dark ? theme.colors.typographyHeadersLight : theme.colors.typographyBodyLight};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
